import React from 'react';
import { VStack, HStack, Text, useColorModeValue } from '@chakra-ui/react';

export default function AriveLoanTeamCard({ loanData }) {
  const mutedColor = useColorModeValue('gray.500', 'gray.400');

  const teamMembers = [];

  if (loanData.loanOriginatorName) {
    teamMembers.push({ role: 'Originator', name: loanData.loanOriginatorName, email: loanData.loanOriginatorEmail });
  }
  if (loanData.loanProcessorName) {
    teamMembers.push({ role: 'Processor', name: loanData.loanProcessorName, email: loanData.loanProcessorEmail });
  }
  if (loanData.loanOfficerAssistantName) {
    teamMembers.push({ role: 'LOA', name: loanData.loanOfficerAssistantName, email: loanData.loanOfficerAssistantEmail });
  }

  if (loanData.loanTeam) {
    for (const member of loanData.loanTeam) {
      const exists = teamMembers.some((tm) => tm.email === member.emailAddressText);
      if (!exists) {
        teamMembers.push({
          role: member.loanRole || 'Team',
          name: `${member.firstName || ''} ${member.lastName || ''}`.trim(),
          email: member.emailAddressText,
        });
      }
    }
  }

  if (teamMembers.length === 0) {
    return <Text fontSize="xs" color={mutedColor}>No loan team data</Text>;
  }

  return (
    <VStack align="stretch" spacing={2}>
      {teamMembers.map((m, i) => (
        <HStack key={i} justify="space-between" align="start">
          <Text fontSize="xs" color={mutedColor} minW="70px">{m.role}</Text>
          <VStack align="end" spacing={0}>
            <Text fontSize="xs" fontWeight="medium">{m.name}</Text>
            {m.email && <Text fontSize="10px" color={mutedColor}>{m.email}</Text>}
          </VStack>
        </HStack>
      ))}
    </VStack>
  );
}
